<template>
  <div id="app">
    <keep-alive>
      <!-- <transition v-if="$route.meta.keepAlive" name="dialogFade"> -->
        <router-view v-if="$route.meta.keepAlive"></router-view>
      <!-- </transition> -->
    </keep-alive>

    <!-- <transition v-if="!$route.meta.keepAlive" name="dialogFade"> -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- </transition> -->
    <tab-bar v-if="$route.meta.showTabBar" />
  </div>
</template>

<script>
import TabBar from '@/components/TabBar.vue'
export default {
  name: 'App',
  components: {
    TabBar
  },
  data() {
    return {
      active: 0,
      tabBars: [{
        path: '/home',
        url: require('@/assets/icons/home-icon.png'),
        activeUrl: require('@/assets/icons/active-home.png'),
        menuName: '首页'
      },
      {
        path: '/mine',
        url: require('@/assets/icons/mine-icon.png'),
        activeUrl: require('@/assets/icons/active-mine.png'),
        menuName: '我的'
      },],
      isRouterAlive: true
    }
  },
  methods: {
  },
  computed: {
    currentPath() {
      return this.$route.path;
    }
  },
}
</script>
<style lang="scss">
.dialogFade-leave-to {
  display: none;
}

.dialogFade-enter,
.dialogFade-leave-to {
  opacity: 0;
  transform: translateY(-30px);
  position: absolute;
}

/* 过程 */
.dialogFade-enter-active {
  transition: all 0.8s;
}

/* 结束 */
.dialogFade-enter-to {
  opacity: 1;
}

.dialogFade-leave-active {
  transition: all 0.8s;
}
</style>
<style>
#app {
  padding-bottom: 100px;
  height: 100vh;
  background-color: #f5f5f7;
}
</style>
